// Upload cap matches the Workers Free/Pro request-body limit (100 MB).
export const MAX_DOWNLOAD_BYTES = 100_000_000;
export const MAX_UPLOAD_BYTES = 100_000_000;

export const DOWNLOAD_PATH = '/down';
export const UPLOAD_PATH = '/up';
